import React, { useState } from 'react';

import { withRouter } from "react-router-dom";

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { sports } from '../enum/sports';

import { API } from 'aws-amplify';


import { createContact } from '../graphql/mutations';
import ContactDialog from './contactDialog';

//material ui-theme - move to central location
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        backgroundColor: 'white'
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        backgroundColor: 'white'
    },
}));

function Contact() {
    const classes = useStyles();
    const [formState, setFormState] = useState({
        firstName: '',
        lastName: '',
        school: '',
        sport: '',
        phone: '',
        referral: '',
        message: '',
        email: ''
    })

    const handleContactFormSubmit = async (e) => {
        //e.preventDefault()
        const {
            firstName,
            lastName,
            school,
            sport,
            phone,
            referral,
            message,
            email
        } = formState

        if (message && email) {
            await API.graphql({
                query: createContact,
                variables: {
                    input: {
                        firstName,
                        lastName,
                        school,
                        sport,
                        phone,
                        referral,
                        message,
                        email
                    },
                },
            })
        }
        setFormState({
            firstName: '',
            lastName: '',
            school: '',
            sport: '',
            phone: '',
            referral: '',
            message: '',
            email: ''
        });
    }




    return (
        <div className="contact">

            <div className="row">
                <div className="container pt-5">
                    <h1 className="mx-auto">CONTACT US</h1>
                </div>
                <div className="container mt-3">
                    <p className="mx-auto mb-2">Looking to host an event? Just have a question? Send a message our way using the form below and we will reach out to you ASAP!</p>
                    <h2>Fill out the form to contact us:</h2>

                    <div className="row mt-3">
                        <div className="col-6">
                            <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                <InputLabel shrink >First Name</InputLabel>
                                <TextField
                                    placeholder="John"

                                    variant="outlined"
                                    className={classes.textField}
                                    value={formState.firstName}
                                    onChange={(e) =>
                                        setFormState({ ...formState, firstName: e.target.value })
                                    }
                                />
                            </FormControl>
                        </div>
                        <div className="col-6">
                            <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                <InputLabel shrink >Last Name</InputLabel>
                                <TextField
                                    placeholder="Smith"

                                    variant="outlined"
                                    className={classes.textField}
                                    value={formState.lastName}
                                    onChange={(e) =>
                                        setFormState({ ...formState, lastName: e.target.value })
                                    }
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                <InputLabel shrink >School</InputLabel>
                                <TextField
                                    placeholder="My School"

                                    variant="outlined"
                                    className={classes.textField}
                                    value={formState.school}
                                    onChange={(e) =>
                                        setFormState({ ...formState, school: e.target.value })
                                    }
                                />
                            </FormControl>
                        </div>
                        <div className="col-6">
                            <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                <InputLabel shrink >Sport</InputLabel>
                                <Select

                                    className={classes.selectEmpty}
                                    value={formState.sport}
                                    onChange={e => setFormState({ ...formState, 'sport': e.target.value })}
                                >
                                    <MenuItem value=""><em>None</em></MenuItem>
                                    {Object.keys(sports).map(key => (
                                        <MenuItem value={key}>{sports[key].name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                <InputLabel shrink >Email Address</InputLabel>
                                <TextField
                                    placeholder="jsmith@email.com"


                                    variant="outlined"
                                    className={classes.textField}
                                    value={formState.email}
                                    onChange={(e) =>
                                        setFormState({ ...formState, email: e.target.value })
                                    }
                                />
                            </FormControl>
                        </div>
                        <div className="col-6">
                            <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                <InputLabel shrink >Phone Number</InputLabel>
                                <TextField
                                    placeholder="555-555-5555"


                                    variant="outlined"
                                    className={classes.textField}
                                    value={formState.phone}
                                    onChange={(e) =>
                                        setFormState({ ...formState, phone: e.target.value })
                                    }
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                <InputLabel shrink >How did you hear about us?</InputLabel>
                                <TextField
                                    variant="outlined"
                                    className={classes.textField}
                                    value={formState.referral}
                                    onChange={(e) =>
                                        setFormState({ ...formState, referral: e.target.value })
                                    }
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <FormControl variant="outlined" fullWidth className={classes.formControl}>
                                <InputLabel shrink >What would you like to talk to us about?</InputLabel>
                                <TextField
                                    variant="outlined"
                                    className={classes.textField}
                                    placeholder="I am an athlete and am interested in hosting a camp this next summer!"
                                    multiline
                                    rows={10}
                                    value={formState.message}
                                    onChange={(e) =>
                                        setFormState({ ...formState, message: e.target.value })
                                    }
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-12 col-lg-6 col-xl-6 col-sm-12 mx-auto">

                            <ContactDialog
                                formSubmit={handleContactFormSubmit}
                            />


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withRouter(Contact);